import { useContext, useState } from "react";
import { CartContext } from "../context/cartcontext";
import { AuthContext } from "../context/usercontext";
import { db } from "../FirebaseConfig";
import firebase from 'firebase';
import CardForm from "./CardForm";
import Popup from "./Popup";
import { useHistory } from "react-router-dom";

const Checkout = () => {
    const history = useHistory();
    
    const [message, setMessage] = useState('');
    const [header, setHeader] = useState('');

    const {user} = useContext(AuthContext);
    const {setCart ,cart, total} = useContext(CartContext);
    const [currdata, setCurrdata] = useState('');

    const [show, setShow] = useState(false);

    const handleClose = () => { 
        if (header === 'Success') {
            setShow(false);
            setCart([]);
            history.push('/');
        }
        setShow(false);
        
    };
    const handleShow = () => setShow(true);

   db.collection("USERS").get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            if (user.email === doc.data().user_email){
                setCurrdata(doc.id);
            }
        });
    });

    const [name, setName] = useState('');
    const [card, setCard] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [cvv, setCvv] = useState('');

    const Pay = (e) => {
        e.preventDefault();

        if (name !== '' && card !== '' && card.length === 16 && cvv !== '' && month !== '' && year !== ''){
            db.collection('USERS').doc(currdata).collection('ORDERS').add({
                timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                name : name,
                card : card,
                cvv : cvv,
                month : month,
                year : year,
                orders : JSON.stringify(cart),
                total : total
            });
            setMessage('Woohoo, your order is registered and will be delivered quickly. Thank you for shopping with us.');
            setHeader('Success');
            handleShow();
        }
        else {
            setMessage('Please enter appropriate data.');
            setHeader('Failure');
            handleShow();
        }
        
    }

    return(
        <div className = 'pay'>
            <div>
                <h4>Payment Portal</h4>
                <h5>Total Bill : {total}</h5>
                    <CardForm setName = {setName} setCard = {setCard} 
                              setMonth = {setMonth} setYear = {setYear} 
                              setCvv = {setCvv} Pay = {Pay} 
                    />
                <Popup show = {show} handleClose = {handleClose} message = {message} header = {header}/>
            </div> 
        </div>
    );
}

export default Checkout;